export default __webpack_public_path__ + "static/media/wifi_good_signal.e2a1737a.svg";